"use strict";
/**
 * On click, scrolls user to top of current page
 *
 * @param {String} id - The id of the element, set as a string
 */
function initLottieAnimation(id) {
    const element = document.querySelector(id);
    if (element) {
        element.addEventListener("ready", () => {
            element.stop();
            element.seek(1);
            setTimeout(() => {
                element.play();
            }, 200);
        });
    }
}
initLottieAnimation("#lottieHome");
